import React from "react";
import { Descriptions, Empty, Modal, Tag } from "antd";
import type { MasterProduct } from "../types";

export type MasterProductDetailModalProps = {
  open: boolean;
  product?: MasterProduct | null;
  onClose: () => void;
};

const formatDate = (value?: string) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
};

export const MasterProductDetailModal: React.FC<
  MasterProductDetailModalProps
> = ({ open, product, onClose }) => {
  return (
    <Modal
      title="Master Product Details"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={620}
      destroyOnClose
      className="modal-round master-product-detail-modal"
    >
      {product ? (
        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label="Master Product Code">
            {product.product_code || "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Product Name">
            {product.name}
          </Descriptions.Item>
          <Descriptions.Item label="Category">
            {product.category_name || "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Default Unit">
            {product.default_unit}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={product.is_active ? "success" : "default"}>
              {product.is_active ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Created Date">
            {formatDate(product.created_at)}
          </Descriptions.Item>
          <Descriptions.Item label="Updated Date">
            {formatDate(product.updated_at)}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Empty description="No master product found." />
      )}
    </Modal>
  );
};

export default MasterProductDetailModal;
